// extracted by css-extract-rspack-plugin
export default {"Button":"dropdown-caret-module__Button__xxO4Z"};